import { render } from "./UserUpdateUniversity.vue?vue&type=template&id=27b62d44&scoped=true"
import script from "./UserUpdateUniversity.vue?vue&type=script&lang=js"
export * from "./UserUpdateUniversity.vue?vue&type=script&lang=js"

import "./UserUpdateUniversity.vue?vue&type=style&index=0&id=27b62d44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b62d44"]])

export default __exports__